import { useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Booking() {
  useEffect(() => {
    // Load iFrameResizer script
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/2.8.3/iframeResizer.min.js';
    script.async = true;
    script.onload = () => {
      // Initialize iFrameResize after script loads
      if (window.iFrameResize) {
        window.iFrameResize({ checkOrigin: false }, '#reservationIframe86267');
      }
    };
    document.body.appendChild(script);

    return () => {
      // Cleanup
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.div
      id="booking"
      className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-8 md:py-12 lg:py-16 bg-Neautral-white flex flex-col justify-start items-start gap-8"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={containerVariants}
    >
      <motion.div className="self-stretch flex flex-col justify-center items-center" variants={itemVariants}>
        <span className="text-Neautral-main text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight" style={{ fontFamily: "'Prata', serif" }}>
          Book time
        </span>
      </motion.div>

      <motion.div className="w-full" variants={itemVariants}>
        <iframe
          title="Studio Søraa Booking"
          width="100%"
          frameBorder="0"
          src="https://bestill.timma.no/reservation/studiosoraa"
          id="reservationIframe86267"
          style={{ minHeight: '600px' }}
        />
      </motion.div>
    </motion.div>
  );
}
